import * as React from 'react'
import Button from '@mui/material/Button'
import { useFormikContext } from 'formik'

import { CancelButton } from '../CancelButton'
import DialogActions from '@mui/material/DialogActions/DialogActions'
import { BackButton } from '../BackButton'

export function Footer() {
  const { submitForm } = useFormikContext()

  return (
    <DialogActions
      sx={{
        px: 2.4,
        pb: 2.4,
      }}
    >
      <CancelButton />
      <BackButton />
      <Button
        variant="contained"
        onClick={submitForm}
        data-test-id="filters-submitBtn"
      >
        Continue
      </Button>
    </DialogActions>
  )
}
